import React from 'react';
import CongratulationsImg from '../../assets/images/congratulations.png';

function CongratulationsImage() {
  return (
    <img alt="Congratulations!" src={CongratulationsImg} width={200} height={100} loading="lazy" />
  );
}

export { CongratulationsImage };
